import { lazy } from 'react';
import { RouteConfig } from '../../types';

const ContractIdDetails = lazy(() =>
  import('@web/apps/ContractIdDetails/ContractIdDetails').then((module) => ({
    default: module.ContractIdDetails,
  }))
);

export const contractIdDetailsRoutes: RouteConfig[] = [
  {
    path: 'contract-id-details',
    component: ContractIdDetails,
    guards: ['auth'],
    data: {
      title: 'Contract ID Details',
      breadcrumb: 'Contract ID Details',
      preload: false,
      delay: false,
    },
  },
];
